import { render, staticRenderFns } from "./FlexPanel.vue?vue&type=template&id=e5530f94&scoped=true"
import script from "./FlexPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlexPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FlexPanel.vue?vue&type=style&index=0&id=e5530f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5530f94",
  null
  
)

export default component.exports